<template>
  <Modal title="Course Report" v-model="showModal" width="750">
    <div class="evaluate">
      <h3>Part one： Overall Performance(minimum 2 stars, maximum 5 stars)  :</h3>
      <Form  ref="formData"
         class="feedback form regluarForm" label-position="top" v-model="formData">
        <Row>
          <Col :span="20" >
            <Form-item label="Comprehension：">
              <el-rate v-model="formData.rate1"  @change="handleChange"></el-rate>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="20" >
            <Form-item label="Speaking Skill：">
              <el-rate v-model="formData.rate2" @change="handleChange"></el-rate>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="20" >
            <Form-item label="Pronunciation：">
              <el-rate v-model="formData.rate3"  @change="handleChange"></el-rate>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="20" >
            <Form-item label="Vocabulary：">
              <el-rate v-model="formData.rate4"  @change="handleChange"></el-rate>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="20" >
            <Form-item label="Use of Expression：">
              <el-rate v-model="formData.rate5"  @change="handleChange"></el-rate>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="20" >
            <Form-item label="Sentence Construction：">
              <el-rate v-model="formData.rate6"  @change="handleChange"></el-rate>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="evaluate">
        <h3>Part two: Teacher's Feedback   :</h3>
        <p>Please list at least 1 point which the student really did well, and 1 point which the student
really needs to improve
You can write your suggestions according to the student's speaking, listening, usage of
sentences, adaptability. Interaction with the teacher.</p>
        <h4>Improvements：(at least 20 words)  :</h4>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="Enter something..."
          v-model="formData.word1">
        </el-input>
        <h4>Difficulties：(at least 20 words)  :</h4>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="Enter something..."
          v-model="formData.word2">
        </el-input>
        <h4>Suggestions：(at least 30 words)  :</h4>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="Enter something..."
          v-model="formData.word3">
        </el-input>
    </div>
    <div slot="footer">
      <Button type="text" size="large" @click="onClose">Cancel</Button>
      <Button v-if="!readonly" type="primary" size="large" :loading="loading" @click="onSubmit">Submit</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'StudentWriteReviewFinishLevelV2',
    props: {
      formData: {
        type: Object,
        default: {
          return: {
            rate1: 2,
            rate2: 2,
            rate3: 2,
            rate4: 2,
            rate5: 2,
            rate6: 2,
            word1: '',
            word2: '',
            word3: '',
          }
        }
      },
      value: {
        type: Boolean,
        default: {
          return: false
        }
      },
      openedId: {
        type: Number
      },
      reviewState: {
        type: Number
      },
      successCallback: {
        type: Function
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        uid: '',
        openid: '',
        state: '',
        form: {
          rating: 4
        },
        rateValue: 0,
        v1: 4,
        v2: 2,
        showModal: this.value,
        loading: false,
        lessonErrRule: {
          remark: [
            { type: 'string', required: true, message: ' ', trigger: 'blur' }
          ],
        }
      }
    },
    methods: {
      changeFile (fileList) {
        this.formData.fileList = fileList
      },
      deleteItem (element, index, limit) {
        if (element.length === 1) {
          this.$Message.warning(`can't not remove defalut input`)
          return
        }
        if (element.length > limit) {
          element.splice(index, 1)
        } else {
          this.$Message.warning(`At least ${limit} words!`)
        }
      },
      addItem (element) {
        element.push({ remark: '' })
      },
      handleChange (value) {
        this.formData.rate1 = this.formData.rate1 > 2 ? this.formData.rate1 : 2
        this.formData.rate2 = this.formData.rate2 > 2 ? this.formData.rate2 : 2
        this.formData.rate3 = this.formData.rate3 > 2 ? this.formData.rate3 : 2
        this.formData.rate4 = this.formData.rate4 > 2 ? this.formData.rate4 : 2
        this.formData.rate5 = this.formData.rate5 > 2 ? this.formData.rate5 : 2
        this.formData.rate6 = this.formData.rate6 > 2 ? this.formData.rate6 : 2
      },
      starChange (v) {
        console.log(this.v2)
        console.log(this.v2)
      },
      onClose () {
        this.$emit('on-close')
      },
      getWord (element) {
        if (!element) {
          return []
        }
        let word = []
        element.match(/[^,，\s]+/g).forEach(v => {
          if (v.trim() !== '') {
            word.push(v.trim()) // 去除单词前后的空格
          }
        })
        return word
      },
      hasNumWords (str, num) {
        const words = str.split(' ') // 将字符串按空格切割成单词数组
        return words.length >= num // 判断单词数量是否大于等于80
      },
      onload () {
        let self = this
        self.$http.get('/bookTchFeedback/queryByLsnOpenId?lsnOpenId=' + self.openid).then(res => {
          let {uid, goodComment} = res.data
          self.uid = uid
          if (goodComment) {
            let {part1, part2} = JSON.parse(goodComment)
            let rateList = part1.split(',')
            let intList = rateList.map(v => parseInt(v, 10))
            if (rateList.length >= 6) {
              [this.formData.rate1, this.formData.rate2, this.formData.rate3, this.formData.rate4, this.formData.rate5, this.formData.rate6] = intList
            }
            this.handleChange() // 判断一下 rate的值
            this.formData.word1 = part2[0]
            this.formData.word2 = part2[1]
            this.formData.word3 = part2[2]
          } else {
            [this.formData.rate1, this.formData.rate2, this.formData.rate3, this.formData.rate4, this.formData.rate5, this.formData.rate6] = [2, 2, 2, 2, 2, 2]
            this.formData.word1 = ''
            this.formData.word2 = ''
            this.formData.word3 = ''
          }
        })
      },
      onSubmit () {
        let self = this
        let word1 = this.getWord(this.formData.word1)
        if (word1.length < 20) {
          this.$Message.error('1.Improvements of the words: At least 20 words!')
          return
        }
        let word2 = this.getWord(this.formData.word2)
        if (word2.length < 20) {
          this.$Message.error('2.Difficulties of the words: At least 20 words!')
          return
        }
        let word3 = this.getWord(this.formData.word3)
        if (word3.length < 30) {
          this.$Message.error('3.Suggestions of the words: At least 30 words!')
          return
        }

        let part1 = []
        part1.push(this.formData.rate1 + '')
        part1.push(this.formData.rate2 + '')
        part1.push(this.formData.rate3 + '')
        part1.push(this.formData.rate4 + '')
        part1.push(this.formData.rate5 + '')
        part1.push(this.formData.rate6 + '')

        console.log('word1', this.formData.word1)
        let part2 = {
          0: this.formData.word1,
          1: this.formData.word2,
          2: this.formData.word3
        }
        let data = {
          part1: part1.join(','),
          part2: part2,
        }
        let parmas = {}
        parmas.goodComment = JSON.stringify(data)
        parmas.lsnOpenId = self.openid
        parmas.reviewState = self.state
        parmas.uid = self.uid
        parmas.version = 2
        this.$http.post('/bookTchFeedback/update', parmas).then(function (res) {
          if (res && res.status === 'ok') {
            self.$Message.success('success!')
            self.showModal = false
            self.$emit('on-close')
            self.successCallback()
          }
        }).catch(function (e) {
          // this.loadingUpdate = false
        })
      },
    },
    watch: {
      reviewState (val) {
        this.state = val
      },
      openedId (val) {
        this.openid = val
      },
      myValue (val) {
        this.myValue = 2
        this.v1 = 3
        this.$nextTick()
      },
      value (val) {
        this.showModal = val
        if (val === true) {
          this.onload()
        } else {
          // this.feedback = {}
          // this.visible = val
        }
      },
      showModal (val) {
        if (val === false) {
          this.$emit('on-close')
        }
      },
      formData (val) {
        if (val) {
          this.lessonErrFormData = val
        }
      }
    }
  }
</script>
<style>
.title {
padding: 10px 0px 10px 0px ;
font-size: 16px;
}
.msg::after {
content: 'bug';
}
.square {
margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// StudentWriteReviewFinishLevelV2Modal.vue?19dd7919